export class CollectionPushSection extends HTMLElement {
    connectedCallback() {
      this.infosVideos       = this.querySelectorAll('.collection-push-section__video');

      this._initVideos();

    }

    /**
     * INIT VIDEO FROM IFRAME
     */
    _initVideos() {
      this.infosVideos.forEach(function(value, index) {
        value.setAttribute('src', value.getAttribute('data-src'));
      });
    }
  
}

try {
  window.customElements.define('collection-push-section', CollectionPushSection);
} catch(e) {}